

import React, { useState } from 'react'
import ProductList from '../../components/ProductCardAll/ProductList/ProductList'
import StoreRightFilter from '../../components/Store/StoreRightFilter/StoreRightFilter'
import StoreSortOption from '../../components/Store/StoreSortOption/StoreSortOption '
// import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import Meta from '../../components/Meta/Meta'
import './Store.css'
function Products() {
    const [showFilterModal, setShowFilterModal] = useState(false);
    return (
        <>
            <div className="container-fluid bg-sec marginTop position-relative">
                <Meta title={' فروشگاه تایتان'} />
                {/* <BreadCrumb title="فروشگاه تایتان " /> */}
                <div className="container-xxl py-3">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-3 d-none d-xl-block ">
                                <div className="row px-2">
                                    <StoreRightFilter />
                                </div>
                            </div>
                            <div className="col-12 col-xl-9 ">
                                <div className="row products-wrapper ">
                                    <StoreSortOption />
                                    <ProductList withDetailsModal={true} />
                                </div>
                                <div className="d-flex justify-content-center pagination-product pt-4">
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            <li className="page-item">
                                                <a className="page-link" href="#" aria-label="Previous">
                                                    <span aria-hidden="true">&laquo;</span>
                                                </a>
                                            </li>
                                            <li className="page-item"><a className="page-link" href="#">1</a></li>
                                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                                            <li className="page-item"><a className="page-link" href="#">3</a></li>

                                            <li className="page-item">
                                                <a className="page-link" href="#" aria-label="Next">
                                                    <span aria-hidden="true">&raquo;</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="mobile-filters d-xl-none" onClick={() => setShowFilterModal(true)}><i className="bi bi-funnel"></i> </div>
            {showFilterModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">فیلتر ها</h5> 
                                <button
                                    type="button"
                                    className="close border-0 rounded-5 h4 px-2 pt-1 text-danger"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setShowFilterModal(false)}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <StoreRightFilter />
                        </div>
                    </div>
                </div>
            )}


        </>


    )
}

export default Products